import { Controller, useForm } from 'react-hook-form';

import { CreateTrackableList } from 'types/trackables';

import { useCreateTrackableList } from '../hooks/useCreateTrackableList';
import { TRACKABLE_OBJECT_TYPE_OPTIONS } from '../utils';

import { Button } from 'components/Button/Button';
import { ButtonGroup } from 'components/ButtonGroup/ButtonGroup';
import { Field } from 'components/Field/Field';
import { Input } from 'components/Input/Input';
import { Select } from 'components/Select/Select';

export interface AddTrackableListFormProps {
  onSuccess?: () => void;
}

export function AddTrackableListForm({ onSuccess }: AddTrackableListFormProps) {
  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<CreateTrackableList>({
    defaultValues: {
      name: '',
      description: '',
      object_type: 'face',
    },
  });

  const { mutate: createTrackableList, isLoading } = useCreateTrackableList({
    onSuccess: () => {
      reset();
      onSuccess?.();
    },
  });

  const onSubmit = (data: CreateTrackableList) => {
    createTrackableList(data);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="space-y-4">
        <Field label="Name" required error={errors.name?.message}>
          <Input
            {...register('name', {
              required: 'Please enter a name for the trackable list.',
            })}
            placeholder="Enter list name..."
          />
        </Field>

        <Field label="Description">
          <Input
            {...register('description')}
            placeholder="Enter description (optional)..."
          />
        </Field>

        <Field label="Object Type" required>
          <Controller
            name="object_type"
            control={control}
            rules={{ required: 'Please select an object type.' }}
            render={({ field: { value, onChange } }) => (
              <Select
                value={TRACKABLE_OBJECT_TYPE_OPTIONS.find(
                  (opt) => opt.value === value
                )}
                onChange={(option) => onChange(option?.value)}
                options={TRACKABLE_OBJECT_TYPE_OPTIONS}
                placeholder="Select object type"
              />
            )}
          />
        </Field>
      </div>

      <div style={{ marginTop: '1.5rem' }}>
        <ButtonGroup>
          <Button type="submit" variant="primary" loading={isLoading}>
            Create List
          </Button>
        </ButtonGroup>
      </div>
    </form>
  );
}
